export const INTRODUCE_STEPS_DESCRIPTION = {
  2: "Quý khách đăng nhập bằng số điện thoại thành viên và OTP gửi về.",
  3: "Quý khách chọn địa điểm đổi quà và quà tặng.",
  4: "Sau khi quý khách đổi quà thành công sẽ xuất hiện giao dịch tại lịch sử đổi quà.",
  5: "Tại mục lịch sử nhận quà, đối với quà chưa nhận sẽ hiển thị nút nhận quà. Quý khách đưa màn hình cho nhân viên cửa hàng thao tác.",
  6: "Nhân viên thao tác ra hóa đơn và trao quà tặng cho quý khách. Ở mục lịch sử tích tem sẽ hiển thị giao dịch đã hoàn thành.",
}

export const GIFT_NOTE = [
  "Quý khách sẽ nhận thông tin mã voucher/ phiếu mua hàng qua tin nhắn điện thoại. Thời gian nhận phiếu sẽ mất khoảng 10 ngày kể từ lúc đổi.",
  "Trong trượng hợp khách hàng không nhận được tin nhắn vui lòng liên hệ Hotline 1900 1708 để được hỗ trợ.",
]

export const GIFT_RULES_DESCRIPTION = [
  "Mỗi hóa đơn trị giá 350k được nhận 1 tem. (Hóa đơn không bao gồm các sản phẩm Flash sale)",
  "Lũy tiến tích tem trên giá trị bill ( 700k được 2 tem, 1.050k được 3 tem,...)",
  "Quý khách tham gia chương trình dùng 1 số điện thoại trên tất cả các hóa đơn.",
  "Quý khách thu thập đủ số tem sẽ nhận được 1 quà tặng tương ứng trong các mốc.",
  "Trong trường hợp quý khách đổi quà là sản phẩm Tefal, quý khách vui lòng liên hệ cửa hàng để chuẩn bị quà trước.",
]

export const ACCUMULATION_TEM_DATE = "1/3 - 30/4/2024"
export const EXCHANGE_GIFT_DATE = "1/3 - 15/5/2024"

export const ACCUMULATION_TEM_WEBSITE = "tichtem.gkitchen.com.vn"
export const HOTLINE = "1900 1708"

export const TIME_TO_RECEIVE_VOTE = "10"
